import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_OFFERS = createActionTypes('FETCH_OFFERS');
export const GET_OFFERS = createActionTypes('GET_OFFERS');
export const CREATE_OFFERS = createActionTypes('CREATE_OFFERS');
export const UPDATE_OFFERS = createActionTypes('UPDATE_OFFERS');
export const DELETE_OFFERS = createActionTypes('DELETE_OFFERS');
